import React from 'react';
import { isNumber } from 'lodash';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';

interface CellProps {
  value: Number;
  getValue: Function;
}

interface NumberCellProps {
  cell: CellProps;
}

function NumberCell(props: NumberCellProps) {
  const { cell } = props;
  let value = null;
  const suffix = `${cell?.column?.suffix || ''}`;
  // Temp fix for asset super table 0 value
  if (cell?.getValue) {
    value = cell.getValue();
  } else {
    value = cell.value;
  }

  return isNumber(value) ? (
    <span>
      {value}
      {suffix}
    </span>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default NumberCell;
